import React, { useState, useEffect } from "react";
import "./Budget.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc, getDoc } from "firebase/firestore";

window.budgetapproved = 0;
window.emplist = [];

const SSHPending = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [demands, setDemands] = useState({});
  const [budgetData, setBudgetData] = useState({
    ageneral: 0,
    ascsp: 0,
    acfld: 0,
    anicra: 0,
    aother: 0,
    ugeneral: 0,
    uscsp: 0,
    ucfld: 0,
    unicra: 0,
    uother: 0,
    bgeneral: 0,
    bscsp: 0,
    bcfld: 0,
    bnicra: 0,
    bother: 0,
  });
  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (!month || !year) return;

    // Set emplist based on empId
    if (empId === "82") {
      window.emplist = ["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"];
    } else if (empId === "83") {
      window.emplist = ["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75", "83"];
    } else if (empId === "84") {
      window.emplist = ["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77", "84"];
    } else if (empId === "85") {
      window.emplist = ["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79", "85"];
    } else if (empId === "86") {
      window.emplist = ["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81", "86"];
    }
    console.log("emplist:", window.emplist);

    const fetchActionPlan = async () => {
      try {
        const q = query(
          collection(db, "actionplan"),
          where("empid", "in", window.emplist),
          where("month", "==", String(month + " " + year))
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setActionPlan([]);
          setDemands({});
          return;
        }

        const actions = [];
        const demandsObj = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // Apply filters: only include documents where accremarks and ddoremarks are not empty
          if (
            data.ddoremarks && data.ddoremarks !== ""
          ) {
            const id = doc.id;

            const demandDate = data.demanddate?.toDate
              ? data.demanddate.toDate().toLocaleDateString("en-GB")
              : "N/A";
            const accdate = data.accdate?.toDate
              ? data.accdate.toDate().toLocaleDateString("en-GB")
              : "N/A";
            const ddodate = data.ddodate?.toDate
              ? data.ddodate.toDate().toLocaleDateString("en-GB")
              : "N/A";
            const sshdate = data.sshdate?.toDate
              ? data.sshdate.toDate().toLocaleDateString("en-GB")
              : "N/A";
            const deedate = data.deedate?.toDate
              ? data.deedate.toDate().toLocaleDateString("en-GB")
              : "N/A";

            actions.push({
              id,
              empid: data.empid || "",
              supportdoc: data.supportdoc || "",
              code: data.programCode || "",
              text: data.program || "",
              td: data.td || "",
              totamount: data.totamount || 0,
              budgetApproved: data.budgetapproved || 0,
              currentstatus: data.currentstatus || "Not Placed",
              demanddate: demandDate,
              budgetDemand: data.budgetdemand || "",
              budgethead: data.budgethead || "",
              ddodate,
              ddoremarks: data.ddoremarks || "",
              deeremarks: data.deeremarks || "",
              accremarks: data.accremarks || "",
              kvk: data.kvk || "",
              empname: data.empname || "",
              empdesig: data.empdesig || "",
            });

            demandsObj[id] = {
              empid: data.empid || "",
              td: data.td || "",
              amount: data.budgetdemand || "",
              totamount: data.totamount || 0,
              placed: !!data.budgetdemand,
              currentstatus: data.currentstatus || "Not Placed",
              demanddate: demandDate,
              accdate,
              ddodate,
              sshdate,
              deedate,
              budgethead: data.budgethead || "",
              ddoremarks: data.ddoremarks || "",
              deeremarks: data.deeremarks || "",
              accremarks: data.accremarks || "",
            };
          }
        });

        setActionPlan(actions);
        setDemands(demandsObj);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year, empId]);

  function fy(month, year) {
    const y = parseInt(year);
    if (month === "January" || month === "February" || month === "March") {
      return String(y - 1 + "-" + (y % 1000));
    } else {
      return String(y + "-" + (y % 1000 + 1));
    }
  }

  const handleDemandPlace = async (id) => {
    if (!demands[id]) {
      alert("Demand data not found.");
      return;
    }

    const budgetText = String(demands[id].amount || "").trim();
    const totAmount = parseFloat(demands[id].totamount || 0);
    const budgetHead = demands[id].budgethead || actionPlan.find((action) => action.id === id)?.budgethead || "";

    if (!budgetText || isNaN(totAmount)) {
      alert("Please enter both budget demand and total amount before placing.");
      return;
    }
    if (!budgetHead) {
      alert("Budget head not specified.");
      return;
    }

    try {
      // Update budget in empmaster
      const budgetRef = doc(db, "empmaster", demands[id].empid || empId, fy(month, year), "budget");
      const budgetDoc = await getDoc(budgetRef);
      let updatedUtilized = 0;

      if (budgetDoc.exists()) {
        const budgetData = budgetDoc.data();

        switch (budgetHead) {
          case "General":
            updatedUtilized = (budgetData.ugeneral || 0) + totAmount;
            await updateDoc(budgetRef, { ugeneral: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ugeneral: updatedUtilized }));
            break;
          case "SCSP":
            updatedUtilized = (budgetData.uscsp || 0) + totAmount;
            await updateDoc(budgetRef, { uscsp: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uscsp: updatedUtilized }));
            break;
          case "CFLD Oilseed":
            updatedUtilized = (budgetData.ucfldo || 0) + totAmount;
            await updateDoc(budgetRef, { ucfldo: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ucfldo: updatedUtilized }));
            break;
          case "CFLD Pulse":
            updatedUtilized = (budgetData.ucfldp || 0) + totAmount;
            await updateDoc(budgetRef, { ucfldp: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ucfldp: updatedUtilized }));
            break;
          case "NICRA":
            updatedUtilized = (budgetData.unicra || 0) + totAmount;
            await updateDoc(budgetRef, { unicra: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unicra: updatedUtilized }));
            break;
          case "Natural Farming":
            updatedUtilized = (budgetData.unf || 0) + totAmount;
            await updateDoc(budgetRef, { unf: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unf: updatedUtilized }));
            break;
          case "Sponsored Program":
            updatedUtilized = (budgetData.usponsored || 0) + totAmount;
            await updateDoc(budgetRef, { usponsored: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, usponsored: updatedUtilized }));
            break;
          case "NABARD":
            updatedUtilized = (budgetData.unabard || 0) + totAmount;
            await updateDoc(budgetRef, { unabard: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unabard: updatedUtilized }));
            break;
          case "ARYA":
            updatedUtilized = (budgetData.uarya || 0) + totAmount;
            await updateDoc(budgetRef, { uarya: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uarya: updatedUtilized }));
            break;
          case "Oilseed Mission Village":
            updatedUtilized = (budgetData.uosmv || 0) + totAmount;
            await updateDoc(budgetRef, { uosmv: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uosmv: updatedUtilized }));
            break;
          case "Seed Hub":
            updatedUtilized = (budgetData.useedhub || 0) + totAmount;
            await updateDoc(budgetRef, { useedhub: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, useedhub: updatedUtilized }));
            break;
          case "ATMA":
            updatedUtilized = (budgetData.uatma || 0) + totAmount;
            await updateDoc(budgetRef, { uatma: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uatma: updatedUtilized }));
            break;
          case "Others":
            updatedUtilized = (budgetData.uuniversity || 0) + totAmount;
            await updateDoc(budgetRef, { uuniversity: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uuniversity: updatedUtilized }));
            break;
          default:
            console.error("Invalid budget head: " + budgetHead);
            alert("Invalid budget head selected.");
            return;
        }
      } else {
        console.error("Budget document does not exist for empid:", demands[id].empid || empId);
        alert("Budget document not found.");
        return;
      }

      // Update actionplan
      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, {
        budgetdemand: budgetText,
        totamount: totAmount,
        currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
        cs: 1,
        sshdate: new Date(),
      });

      setDemands((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          placed: true,
          currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
          demanddate: new Date().toLocaleDateString("en-GB"),
        },
      }));
    } catch (error) {
      console.error("Error updating budget demand and totals:", error);
      alert("An error occurred while placing demand. Please try again.");
    }
  };

  const handleForwardToDEE = async (id) => {
    if (!demands[id]) {
      alert("Demand data not found.");
      return;
    }

    try {
      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, {
        currentstatus: `Forwarded to DEE on ${new Date().toLocaleDateString('en-GB')}`,
        sshremarks: "Forwarded to DEE for kind approval",
        sshdate: new Date(),
        cs: 1,
      });

      setDemands((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          currentstatus: `Forwarded to DEE on ${new Date().toLocaleDateString('en-GB')}`,
          deeremarks: "Not Applicable",
        },
      }));
    } catch (error) {
      console.error("Error forwarding to DEE:", error);
      alert("An error occurred while forwarding to DEE. Please try again.");
    }
  };

  const handleApprove = async (id) => {
    if (!demands[id]) {
      alert("Demand data not found.");
      return;
    }

    const totAmount = parseFloat(demands[id].totamount || 0);
    const budgetHead = demands[id].budgethead || actionPlan.find((action) => action.id === id)?.budgethead || "";

    if (isNaN(totAmount)) {
      alert("Please enter a valid total amount before approving.");
      return;
    }
    if (!budgetHead) {
      alert("Budget head not specified.");
      return;
    }

    try {
      // Update budget in empmaster
      const budgetRef = doc(db, "empmaster", demands[id].empid || empId, fy(month, year), "budget");
      const budgetDoc = await getDoc(budgetRef);
      let updatedUtilized = 0;

      if (budgetDoc.exists()) {
        const budgetData = budgetDoc.data();

        switch (budgetHead) {
          case "General":
            updatedUtilized = (budgetData.ugeneral || 0) + totAmount;
            await updateDoc(budgetRef, { ugeneral: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ugeneral: updatedUtilized }));
            break;
          case "SCSP":
            updatedUtilized = (budgetData.uscsp || 0) + totAmount;
            await updateDoc(budgetRef, { uscsp: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uscsp: updatedUtilized }));
            break;
          case "CFLD Oilseed":
            updatedUtilized = (budgetData.ucfldo || 0) + totAmount;
            await updateDoc(budgetRef, { ucfldo: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ucfldo: updatedUtilized }));
            break;
          case "CFLD Pulse":
            updatedUtilized = (budgetData.ucfldp || 0) + totAmount;
            await updateDoc(budgetRef, { ucfldp: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, ucfldp: updatedUtilized }));
            break;
          case "NICRA":
            updatedUtilized = (budgetData.unicra || 0) + totAmount;
            await updateDoc(budgetRef, { unicra: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unicra: updatedUtilized }));
            break;
          case "Natural Farming":
            updatedUtilized = (budgetData.unf || 0) + totAmount;
            await updateDoc(budgetRef, { unf: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unf: updatedUtilized }));
            break;
          case "Sponsored Program":
            updatedUtilized = (budgetData.usponsored || 0) + totAmount;
            await updateDoc(budgetRef, { usponsored: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, usponsored: updatedUtilized }));
            break;
          case "NABARD":
            updatedUtilized = (budgetData.unabard || 0) + totAmount;
            await updateDoc(budgetRef, { unabard: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, unabard: updatedUtilized }));
            break;
          case "ARYA":
            updatedUtilized = (budgetData.uarya || 0) + totAmount;
            await updateDoc(budgetRef, { uarya: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uarya: updatedUtilized }));
            break;
          case "Oilseed Mission Village":
            updatedUtilized = (budgetData.uosmv || 0) + totAmount;
            await updateDoc(budgetRef, { uosmv: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uosmv: updatedUtilized }));
            break;
          case "Seed Hub":
            updatedUtilized = (budgetData.useedhub || 0) + totAmount;
            await updateDoc(budgetRef, { useedhub: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, useedhub: updatedUtilized }));
            break;
          case "ATMA":
            updatedUtilized = (budgetData.uatma || 0) + totAmount;
            await updateDoc(budgetRef, { uatma: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uatma: updatedUtilized }));
            break;
          case "Others":
            updatedUtilized = (budgetData.uuniversity || 0) + totAmount;
            await updateDoc(budgetRef, { uuniversity: updatedUtilized });
            setBudgetData((prev) => ({ ...prev, uuniversity: updatedUtilized }));
            break;
          default:
            console.error("Invalid budget head: " + budgetHead);
            alert("Invalid budget head selected.");
            return;
        }
      } else {
        console.error("Budget document does not exist for empid:", demands[id].empid || empId);
        alert("Budget document not found.");
        return;
      }

      // Update actionplan
      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, {
        currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
        sshremarks: "Program and Budget Approved",
        sshdate: new Date(),
        cs: 1,
        budgetapproved: parseFloat(window.budgetapproved || 0),
        deeremarks: "Not Applicable",
        finalapproval: "Yes",
      });

      setDemands((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
          deeremarks: "Not Applicable",
        },
      }));
    } catch (error) {
      console.error("Error approving program and budget:", error);
      alert("An error occurred while approving. Please try again.");
    }
  };
  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Seeking Approval of SS & Head</h1>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select
            className="dropdown"
            id="dd1"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            <option value="">Month</option>
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        <select
          className="dropdown"
          id="dd2"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          style={{ width: "150px", height: "40px", marginTop: "33px" }}
        >
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th>KVK & Applicant</th>
                <th>Budget Head</th>
                <th>Program Code & Title/Subject</th>
                <th>Supporting Document</th>
                <th>Details of Notesheet</th>
                <th>Accountant Remarks</th>
                <th>DDO Remarks</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action) => (
                <tr key={action.id}>
                  <td>
                    {action.kvk} <br />
                    {action.empname} <br /> {action.empdesig}
                  </td>
                  <td>{action.budgethead}</td>
                  <td>
                    {action.code} <br /> {action.text}
                  </td>
                  <td>
                    {action.supportdoc ? (
                      <a href={action.supportdoc} target="_blank">
                        <button>View Document</button>
                      </a>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    <textarea
                      rows="4"
                      className="textarea-box"
                      value={demands[action.id]?.td || ""}
                      onChange={(e) => {
                        setDemands((prev) => ({
                          ...prev,
                          [action.id]: {
                            ...prev[action.id],
                            td: e.target.value,
                          },
                        }));
                      }}
                      disabled={demands[action.id]?.placed}
                    />
                    <textarea
                      rows="4"
                      className="textarea-box"
                      value={demands[action.id]?.amount || ""}
                      onChange={(e) => {
                        setDemands((prev) => ({
                          ...prev,
                          [action.id]: {
                            ...prev[action.id],
                            amount: e.target.value,
                          },
                        }));
                      }}
                      disabled={demands[action.id]?.placed}
                    />
                    <div hidden>
                      {(window.budgetapproved = parseFloat(demands[action.id]?.totamount || 0))}
                    </div>
                    <input
                      type="number"
                      placeholder="Enter Total Amount"
                      value={demands[action.id]?.totamount || ""}
                      onChange={(e) => {
                        setDemands((prev) => ({
                          ...prev,
                          [action.id]: {
                            ...prev[action.id],
                            totamount: e.target.value,
                          },
                        }));
                      }}
                      disabled={demands[action.id]?.placed}
                      className="textarea-box"
                    />
                    {!demands[action.id]?.placed && (
                      <button
                        className="place-btn full-width"
                        onClick={() => handleDemandPlace(action.id)}
                      >
                        Place Demand
                      </button>
                    )}
                    {demands[action.id]?.placed && (
                      <h4 style={{ color: "green" }}>
                        Demand Placed on {demands[action.id]?.demanddate}
                      </h4>
                    )}
                  </td>
                  <td>
                    <textarea
                      rows="4"
                      className="textarea-box"
                      value={demands[action.id]?.accremarks || ""}
                      readOnly
                    />
                  </td>
                  <td>
                    {demands[action.id]?.placed && (
                      <>
                        <textarea
                          disabled
                          rows="4"
                          placeholder="No DDO Remarks"
                          className="textarea-box"
                          value={demands[action.id]?.ddoremarks || ""}
                          style={{ width: "100%" }}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <button
                          disabled={!demands[action.id]?.currentstatus.includes("SS & Head")}
                            style={{
                              backgroundColor: "lightblue",
                              cursor: "pointer",
                              height: "26px",
                              border: "none",
                              width: "48%",
                            }}
                            className="forward-btn full-width"
                            onClick={() => handleForwardToDEE(action.id)}
                          >
                            Forward to DEE
                          </button>
                          <button
                          disabled={!demands[action.id]?.currentstatus.includes("SS & Head")}
                            style={{
                              backgroundColor: "lightgreen",
                              cursor: "pointer",
                              height: "26px",
                              border: "none",
                              width: "48%",
                            }}
                            className="approve-btn full-width"
                            onClick={() => handleApprove(action.id)}
                          >
                            Approve
                          </button>
                        </div>
                        <h4 style={{ color: "green" }}>
                          {demands[action.id]?.currentstatus}
                        </h4>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

    </div>
  );
};

export default SSHPending;